import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { environment } from 'environments/environment';
import { BehaviorSubject } from 'rxjs';
import { ResponseUser } from './response/ResponseUser';

@Injectable({
  providedIn: 'root'
})
export class UserServiceService {

  private API_URL= environment.apiUrl;

  rows: any;
  onDatatablessChanged: BehaviorSubject<any>;
  
  constructor(private http: HttpClient) { 
    this.onDatatablessChanged = new BehaviorSubject({});
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return new Promise<void>((resolve, reject) => {
      Promise.all([this.getUsers()]).then(() => {
        resolve();
      }, reject);
    });
  }

  public getUsers(): Promise<any[]>{
     return new Promise((resolve,reject)=>{
      this.http.get(this.API_URL+'/user')
      .subscribe((response:ResponseUser)=>{
        this.rows = response.data.users;
        this.onDatatablessChanged.next(this.rows)
        resolve(this.rows);
      },reject)
    })
  }
}
